"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _context = require("./context");

var _jsxRuntime = require("react/jsx-runtime");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var parseProps = function parseProps(props) {
  if (!['undefined', 'string'].includes(_typeof(props.idPrefix))) {
    throw new Error("Invalid value passed for prop \"idPrefix\", expected undefined or string, got ".concat(_typeof(props.idPrefix)));
  }

  return props;
};

var UniqueIdGeneratorProvider = function UniqueIdGeneratorProvider(props) {
  var _parseProps = parseProps(props),
      children = _parseProps.children,
      _parseProps$idPrefix = _parseProps.idPrefix,
      idPrefix = _parseProps$idPrefix === void 0 ? 'i' : _parseProps$idPrefix;

  var nextIdRef = (0, _react.useRef)(0);
  var uniqueIdGenerator = (0, _react.useCallback)(function () {
    return "".concat(idPrefix).concat(nextIdRef.current++);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.UniqueIdGeneratorContextProvider, {
    value: uniqueIdGenerator,
    children: children
  });
};

var _default = UniqueIdGeneratorProvider;
exports["default"] = _default;